import { AuthConfig } from 'angular-oauth2-oidc';
import { environment } from '../../environments/environment';

export const authConfig: AuthConfig = {
  scope:
    'openid profile email offline_access urn:zitadel:iam:user:resourceowner urn:zitadel:iam:org:project:id:zitadel:aud urn:zitadel:iam:org:project:roles',
  responseType: 'code',
  oidc: true,
  clientId: '301634747522678787',
  issuer: 'https://auth.praceprofirmy.cz',
  redirectUri: environment.redirectUri,
  postLogoutRedirectUri: environment.postLogoutRedirectUri,
  requireHttps: environment.requireHttps,
};
